export const SUPPORT_ADD_TICKET_COMMENT = 'SUPPORT_ADD_TICKET_COMMENT'
export const SUPPORT_GO_TO_DRAFT_TICKET = 'SUPPORT_GO_TO_DRAFT_TICKET'
